import React, { createContext, useState, useContext, Dispatch, SetStateAction } from "react";
import {Contract} from './../../documents/interfaces/Contract'
import { FeedMessageDictionary } from "src/interfaces/Lifefeed";
import { Installation } from "src/interfaces/Installation";
import { DeviceInfoDictionary } from "src/interfaces/DeviceInfo";
import { ContractFilter } from "src/interfaces/ContractFilters";

export interface GlobalStateInterfaceApp {
  search:{
    page:number
    searchterm:string
    sortBy:string
    filterBy:ContractFilter
    parametersUpdatedByUrl:boolean
  }
  contracts: Contract[]
  contractsCount:number  
  maxContractsCount:number
  liveData:FeedMessageDictionary
  installations : Installation[]
  installationCount:number
  maxInstallationCount:number
  devices:DeviceInfoDictionary
}

const globalStateContext = createContext({
  stateApp: {} as Partial<GlobalStateInterfaceApp>,
  setStateApp: {} as Dispatch<SetStateAction<Partial<GlobalStateInterfaceApp>>>,
});

const GlobalStateProviderApp = ({
  children,
  value = {} as GlobalStateInterfaceApp,
}: {
  children: React.ReactNode;
  value?: Partial<GlobalStateInterfaceApp>;
}) => {
  const [stateApp, setStateApp] = useState(value);
  return (
    <globalStateContext.Provider value={{ stateApp, setStateApp }}>
      {children}
    </globalStateContext.Provider>
  );
};

const useGlobalStateApp = () => {
  const context = useContext(globalStateContext);
  if (!context) {
    throw new Error("useGlobalState must be used within a GlobalStateContext");
  }
  return context;
};

export { GlobalStateProviderApp, useGlobalStateApp };